if (!customElements.get('steps-media')) {
  class StepsMedia extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelector('util-tabs');

      if (this.tabs) {
        this.onTabChange = (event) => {
          const previousTab = event.detail && event.detail.previousTab;
          const activeTab = event.detail && event.detail.activeTab;
          if (previousTab) this.pausePanel(previousTab.getAttribute('aria-controls'));
          if (activeTab) this.playAutoplay(activeTab.getAttribute('aria-controls'));
        };

        this.tabs.addEventListener('tabChange', this.onTabChange);

        const selectedTab = this.tabs.querySelector('[role="tab"][aria-selected="true"]');
        if (selectedTab) {
          this.playAutoplay(selectedTab.getAttribute('aria-controls'));
        }

        if (window.Shopify && Shopify.designMode) {
          this.onBlockSelect = (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (tab && this.tabs.activateTab) this.tabs.activateTab(tab, false);
          };
          this.addEventListener('shopify:block:select', this.onBlockSelect);
        }
        return;
      }

      const staticPanel = this.querySelector('.static-steps .media-panel');
      if (staticPanel && staticPanel.id) {
        this.playAutoplay(staticPanel.id);
      }
    }

    pausePanel(panelId) {
      const panel = panelId ? document.getElementById(panelId) : null;
      if (panel && window.$s && $s.pauseAllMedia) $s.pauseAllMedia(panel);
    }

    playAutoplay(panelId) {
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel || !window.$s || !$s.playMedia) return;

      const videoWrap = panel.querySelector('.video-wrap[data-step-autoplay]');
      if (!videoWrap) return;

      const video = videoWrap.querySelector('video[data-autoplay]');
      if (video) {
        const playPromise = $s.playMedia(video);
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
        return;
      }

      const iframe = videoWrap.querySelector('iframe.js-youtube, iframe.js-vimeo');
      if (iframe) {
        $s.playMedia(iframe);
      }
    }

    disconnectedCallback() {
      if (this.tabs && this.onTabChange) this.tabs.removeEventListener('tabChange', this.onTabChange);
      if (this.onBlockSelect) this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  customElements.define('steps-media', StepsMedia);
}
